import { on } from '../../js/dom';

// Notification HTML is injected after page load, so the user cards it contains
// have no KTMenu instance until we create one.
function initNotificationUserCards() {
	window.KTMenu?.createInstances?.();
}

let countRefreshTimer = null;

function updateBellBadge(unreadCount) {
	const badge = document.getElementById('theBellBadge');
	if (! badge) {
		return;
	}

	const count = Number(unreadCount) || 0;

	// Keep the poller's baseline in sync, otherwise a count changed locally by
	// mark-as-read looks like a server-side change and refetches the open list.
	if (window.App.notifications) {
		window.App.notifications._lastUnreadCount = count;
	}

	if (count > 0) {
		badge.textContent = count > 99 ? '99+' : String(count);
		badge.style.display = '';
		jQuery(badge).show();
	} else {
		jQuery(badge).hide();
	}
}

function incrementNotificationBadge() {
	const currentText = jQuery('#theBellBadge').text().trim();
	const currentCount = currentText === '99+' ? 99 : Number.parseInt(currentText, 10) || 0;

	updateBellBadge(currentCount + 1);
}

function isNotificationsDrawerOpen() {
	return document.getElementById('kt_notifications')?.classList.contains('drawer-on') === true;
}

// Anything that writes to the server can create a notification for the current
// user, so re-check the count shortly after instead of waiting for the next poll.
function scheduleCountRefresh() {
	window.clearTimeout(countRefreshTimer);
	countRefreshTimer = window.setTimeout(function() {
		window.App.notifications.refreshCount();
	}, 1000);
}

function registerLivewireCountRefresh() {
	window.Livewire?.hook?.('commit', function({ succeed }) {
		succeed(function() {
			scheduleCountRefresh();
		});
	});
}

function currentFilter() {
	return document.getElementById('kt_notifications_list')?.dataset.filter || 'unread';
}

function removeOrphanGroupLabel(card) {
	const previous = card.previousElementSibling;
	const next = card.nextElementSibling;
	if (previous && previous.classList.contains('feed-item-group-label')) {
		if (! next || next.classList.contains('feed-item-group-label')) {
			previous.remove();
		}
	}
}

function updateToggleControls(card, isUnread) {
	card.dataset.read = isUnread ? '0' : '1';
	const action = isUnread ? 'read' : 'unread';
	const label = isUnread ? 'Read' : 'Unread';

	card.querySelectorAll('[data-notification-toggle]').forEach(function(el) {
		el.setAttribute('data-notification-toggle', action);
		if (el.tagName === 'A') {
			el.textContent = 'Mark as ' + label;
		}
	});
}

window.App = window.App || {};

window.App.notificationsDrawer = {
	_list: null,
	_scrollEl: null,
	_loadMoreEl: null,
	_observer: null,
	_loading: false,
	_requestId: 0,

	init: function () {
		this._list = document.getElementById('kt_notifications_list');
		this._scrollEl = document.getElementById('kt_notifications_body');
		this._loadMoreEl = document.getElementById('kt_notifications_load_more');

		if (! this._list || ! this._scrollEl || ! this._loadMoreEl) {
			return;
		}

		if (typeof IntersectionObserver === 'undefined') {
			this._scrollEl.addEventListener('scroll', this._onScrollFallback.bind(this));
			return;
		}

		this._observer = new IntersectionObserver(this._onLoadMoreVisible.bind(this), {
			root: this._scrollEl,
			rootMargin: '0px 0px 80px 0px',
			threshold: 0,
		});

		if (this._hasMore()) {
			this._observer.observe(this._loadMoreEl);
		}
	},

	setFilter: function (filter) {
		if (! this._list) {
			return;
		}

		this._list.dataset.filter = filter;
		this._list.dataset.cursor = '';
		this._list.dataset.lastBucket = '';
		this._list.dataset.hasMore = '0';
		this._fetch(true);
	},

	setSearch: function (query) {
		if (! this._list) {
			return;
		}

		var next = (query || '').trim();
		if ((this._list.dataset.search || '') === next) {
			return;
		}

		this._list.dataset.search = next;
		this._list.dataset.cursor = '';
		this._list.dataset.lastBucket = '';
		this._list.dataset.hasMore = '0';
		this._fetch(true);
	},

	_onScrollFallback: function () {
		if (this._loading || ! this._hasMore()) {
			return;
		}

		var remaining = this._scrollEl.scrollHeight - (this._scrollEl.scrollTop + this._scrollEl.clientHeight);
		if (remaining > 120) {
			return;
		}

		this._fetch(false);
	},

	_onLoadMoreVisible: function (entries) {
		if (! entries.length || ! entries[0].isIntersecting) {
			return;
		}

		if (this._loading || ! this._hasMore()) {
			return;
		}

		this._fetch(false);
	},

	_hasMore: function () {
		return this._list && this._list.dataset.hasMore === '1';
	},

	_setLoading: function (isLoading) {
		this._loading = isLoading;

		if (this._loadMoreEl) {
			this._loadMoreEl.classList.toggle('is-loading', isLoading);
		}
	},

	_updateLoadMore: function () {
		if (! this._loadMoreEl) {
			return;
		}

		if (this._hasMore()) {
			this._loadMoreEl.classList.remove('d-none');
			this._observer?.observe(this._loadMoreEl);
		} else {
			this._loadMoreEl.classList.add('d-none');
			this._observer?.unobserve(this._loadMoreEl);
		}
	},

	_fetch: function (reset) {
		var self = this;
		var filter = this._list.dataset.filter || 'unread';
		var cursor = reset ? '' : (this._list.dataset.cursor || '');
		var previousBucket = reset ? '' : (this._list.dataset.lastBucket || '');
		var search = this._list.dataset.search || '';

		this._setLoading(true);
		var requestId = ++this._requestId;

		jQuery.ajax({
			type: 'GET',
			url: '/notifications/feed',
			dataType: 'json',
			data: {
				filter: filter,
				cursor: cursor,
				previous_bucket: previousBucket,
				q: search,
			},
			success: function (response) {
				if (requestId !== self._requestId) {
					return;
				}
				if (reset) {
					self._list.innerHTML = response.html || '';
				} else if (response.html) {
					self._list.insertAdjacentHTML('beforeend', response.html);
				}

				self._list.dataset.filter = response.filter || filter;
				self._list.dataset.cursor = response.nextCursor || '';
				self._list.dataset.hasMore = response.hasMore ? '1' : '0';
				self._list.dataset.lastBucket = response.lastBucket || '';

				self._updateLoadMore();
				updateBellBadge(response.unreadCount);
				initNotificationUserCards();
			},
			error: function () {
				if (requestId !== self._requestId) {
					return;
				}
				self._list.dataset.hasMore = '0';
				self._updateLoadMore();
			},
			complete: function () {
				if (requestId !== self._requestId) {
					return;
				}
				self._setLoading(false);
			},
		});
	},
};

function initNotificationsBindings() {
	on(document, 'click', '.notification-actor-name[data-notification-actor-name]', function(e, el) {
		e.preventDefault();

		const trigger = el.parentElement?.querySelector('[data-kt-menu-trigger]');
		if (trigger) {
			setTimeout(function() {
				trigger.click();
			}, 0);
		}
	});

	on(document, 'click', '.notificationNav', function(e, el) {
		e.preventDefault();

		let siblings = el.parentElement.querySelectorAll('.notificationNav');
		siblings.forEach(function(sibling) {
			sibling.classList.add('inactive');
			sibling.setAttribute('aria-selected', 'false');
		});
		el.classList.remove('inactive');
		el.setAttribute('aria-selected', 'true');

		const filter = el.getAttribute('data-notification-filter') || 'unread';
		if (filter === 'unread') {
			jQuery('#kt_notifications_footer').show();
		} else {
			jQuery('#kt_notifications_footer').hide();
		}

		window.App.notificationsDrawer.setFilter(filter);
	});

	var notificationSearchTimer = null;
	on(document, 'input', '#kt_notifications_search', function(e, el) {
		window.clearTimeout(notificationSearchTimer);
		notificationSearchTimer = window.setTimeout(function() {
			window.App.notificationsDrawer.setSearch(el.value);
		}, 250);
	});

	on(document, 'click', '.handleToggleReadUnread', function(e, el) {
		e.preventDefault();

		const card = el.closest('[data-notification-id]');
		if (! card) {
			return;
		}

		const action = el.getAttribute('data-notification-toggle') || (card.dataset.read === '0' ? 'read' : 'unread');
		window.toggleReadUnread(card.getAttribute('data-notification-id'), action);
	});

	jQuery(document)
		.off('click.notifications', '#markAllNotificationsAsRead')
		.on('click.notifications', '#markAllNotificationsAsRead', function(e) {
			e.preventDefault();

			jQuery.ajax({
				url: '/notifications/markallasread',
				method: 'GET',
				dataType: 'json',
				success: function(response) {
					updateBellBadge(response.unreadCount ?? 0);
					if (currentFilter() === 'unread') {
						window.App.notificationsDrawer.setFilter('unread');
					}
				}
			});
		});

	jQuery(document)
		.off('click.notifications', '#kt_notifications_toggle')
		.on('click.notifications', '#kt_notifications_toggle', function() {
			window.triggerNotificationsUpdate();
		});

	jQuery(document).ajaxComplete(function(event, xhr, settings) {
		const method = (settings.type || settings.method || 'GET').toUpperCase();

		if (method !== 'GET') {
			scheduleCountRefresh();
		}
	});

	if (window.Livewire) {
		registerLivewireCountRefresh();
	} else {
		document.addEventListener('livewire:init', registerLivewireCountRefresh);
	}
}

window.showAllNotifications = function() {
	jQuery('#kt_notifications_footer').hide();
};

window.showUnreadNotifications = function() {
	jQuery('#kt_notifications_footer').show();
};

window.triggerNotificationsUpdate = function() {
	if (window.App.notificationsDrawer && window.App.notificationsDrawer._list) {
		window.App.notificationsDrawer.setFilter(currentFilter());
	}
};

window.App.notifications = {
	_lastUnreadCount: null,

	// The bell count is owned by the server so it stays correct regardless of the
	// drawer's current tab or whether the drawer has ever been opened.
	refreshCount: function(options) {
		const self = this;
		const refreshDrawer = options?.refreshDrawer !== false;

		return jQuery.getJSON('/notifications/unread/count').done(function(data) {
			const count = Number.parseInt(data?.count, 10) || 0;
			const changed = self._lastUnreadCount !== null && self._lastUnreadCount !== count;

			self._lastUnreadCount = count;
			updateBellBadge(count);

			if (refreshDrawer && changed && isNotificationsDrawerOpen()) {
				window.triggerNotificationsUpdate();
			}
		});
	},

	received: function() {
		incrementNotificationBadge();

		if (isNotificationsDrawerOpen()) {
			window.triggerNotificationsUpdate();
		}

		return this.refreshCount();
	},
};

window.markAsUnread = function(theID) {
	jQuery.ajax({
		url: '/notifications/markasunread/id/' + theID,
		method: 'GET',
		dataType: 'json',
		success: function(response) {
			const card = document.querySelector('[data-notification-id="' + theID + '"]');
			if (card) {
				updateToggleControls(card, true);
			}
			updateBellBadge(response.unreadCount);
		}
	});
};

window.markAsRead = function(theID) {
	jQuery.ajax({
		url: '/notifications/markasread/id/' + theID,
		method: 'GET',
		dataType: 'json',
		success: function(response) {
			const card = document.querySelector('[data-notification-id="' + theID + '"]');
			if (card) {
				if (currentFilter() === 'unread') {
					removeOrphanGroupLabel(card);
					card.remove();
					if (! document.querySelector('#kt_notifications_list [data-notification-id]')) {
						window.App.notificationsDrawer.setFilter('unread');
					}
				} else {
					updateToggleControls(card, false);
				}
			}
			updateBellBadge(response.unreadCount);
		}
	});
};

window.toggleReadUnread = function(theID, readOrUnread) {
	if (typeof theID === 'undefined' || typeof readOrUnread === 'undefined') {
		return;
	}

	switch (readOrUnread) {
		case 'read':
			window.markAsRead(theID);
			break;
		case 'unread':
			window.markAsUnread(theID);
			break;
	}
};

initNotificationsBindings();

jQuery(function () {
	window.App.notificationsDrawer.init();
	window.App.notifications.refreshCount();
});
